module.exports = __webpack_public_path__ + "images/exclamationMarkYellow-26LN3o0.svg";